<template>
  <!-- 編輯區權人名冊資料列表 -->
  <div id="EditRegisterList_main">
    <el-table
      :key="tableKey"
      ref="editRegisterTable"
      :data="listData"
      row-key="id"
      class="editRegisterListTable"
      :header-cell-class-name="headerCellStyle"
      :row-class-name="rowCellStyle"
      @cell-mouse-enter.once="rowMove"
    >
      <el-table-column
        ref="id"
        type="index"
        width="60"
      />
      <el-table-column
        prop="tabletName"
        label="戶別"
      />
      <el-table-column
        prop="tabletName"
        label="出席狀態"
        min-width="50"
      >
        <template slot-scope="scope">
          <el-tag
            v-if="scope.row.registrationStatus === 'NotRegistered'"
            type="info"
          >
            未報到
          </el-tag>
          <el-tag
            v-if="scope.row.registrationStatus === 'Registered'"
            type="success"
          >
            已報到
          </el-tag>
          <el-tag
            v-if="scope.row.registrationStatus == 'Unregistered'"
            type="warning"
          >
            已簽退
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="unitOwnerName"
        label="區權人姓名"
      >
        <template slot-scope="scope">
          <!-- 可編輯（未報到、新增區權人） -->
          <el-input
            v-if="scope.row.registrationStatus === 'NotRegistered' || !scope.row.registrationStatus"
            v-model="scope.row.unitOwnerName"
            placeholder="請輸入區權人姓名"
            @change="editRow(scope.$index)"
          />
          <!-- 不可編輯（有狀態且為已報到） -->
          <el-tooltip
            v-if="scope.row.registrationStatus && scope.row.registrationStatus === 'Registered'"
            :content="Tooltips.ALREADY_REGISTERED"
            placement="top"
          >
            <p>{{ scope.row.unitOwnerName }}</p>
          </el-tooltip>
          <!-- 不可編輯（有狀態且為已簽退） -->
          <el-tooltip
            v-if="scope.row.registrationStatus && scope.row.registrationStatus === 'Unregistered'"
            :content="Tooltips.ALREADY_UNREGISTERED"
            placement="top"
          >
            <p>{{ scope.row.unitOwnerName }}</p>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="tabletArea"
        :label="`${areaPerPerson}（${unit}）`"
        label-class-name="areaPerPerson"
      >
        <template slot-scope="scope">
          <!-- 可編輯（未報到、新增區權人） -->
          <el-input
            v-if="scope.row.registrationStatus === 'NotRegistered' || !scope.row.registrationStatus"
            v-model="scope.row.tabletArea"
            type="number"
            :class="(scope.row.tabletArea == '' || scope.row.tabletArea <= 0 )? 'borderRed' : ''"
            @change="editRow(scope.$index)"
          />
          <div class="errorTxt">
            <span v-if="scope.row.tabletArea === ''">{{ ErrorMsg.CANT_NOT_BE_EMPTY }}</span>
            <span v-else-if="scope.row.tabletArea < 0">{{ ErrorMsg.CANT_NOT_LESS_THEN_ZERO }}</span>
            <span v-else-if="scope.row.tabletArea === 0">{{ ErrorMsg.CANT_NOT_BE_ZERO }}</span>
          </div>
          <!-- 不可編輯（有狀態且為已報到） -->
          <el-tooltip
            v-if="scope.row.registrationStatus && scope.row.registrationStatus === 'Registered'"
            :content="Tooltips.ALREADY_REGISTERED"
            placement="top"
          >
            <p>{{ scope.row.tabletArea }}</p>
          </el-tooltip>
          <!-- 不可編輯（有狀態且為已簽退） -->
          <el-tooltip
            v-if="scope.row.registrationStatus && scope.row.registrationStatus === 'Unregistered'"
            :content="Tooltips.ALREADY_UNREGISTERED"
            placement="top"
          >
            <p>{{ scope.row.tabletArea }}</p>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        min-width="50"
      >
        <template
          slot-scope="scope"
          class="buttonWrap"
        >
          <!-- 未報到可以刪除 -->
          <el-button
            v-if="scope.row.registrationStatus == 'NotRegistered' && scope.row.mode != 'Delete'"
            type="danger"
            size="mini"
            plain
            @click="delRow(scope.$index)"
          >
            刪除
          </el-button>
          <!-- 新增區權人可以刪除 -->
          <el-button
            v-if="!scope.row.registrationStatus"
            type="danger"
            size="mini"
            plain
            @click="deleteCreatingUnitOwner(scope.$index)"
          >
            刪除
          </el-button>
          <!-- 已報到、已簽退不可刪除 -->
          <!-- <el-tooltip v-if="scope.row.registrationStatus != 'NotRegistered'" content="已完成報到或簽退的戶別資料無法刪除" placement="top">
            <div v-if="scope.row.registrationStatus != 'NotRegistered'" class="delRowButton">
              <el-button type="danger" size="mini" disabled plain>刪除</el-button>
            </div>
          </el-tooltip> -->
        </template>
      </el-table-column>
    </el-table>
    <div class="addButton">
      <CreateUnitOwnerDialog
        ref="createUnitOwnerDialog"
        :delete-list="deleteList"
        @createRow="createRow"
        @deletedToCreate="deletedToCreate"
      />
    </div>
    <TableLoading :is-loading="loading" />
  </div>
</template>
<script>
import TableLoading from '@/components/TableLoading'
import Sortable from 'sortablejs'
import CreateUnitOwnerDialog from './CreateUnitOwnerDialog.vue'
import tw from '../utils'
export default {
  components: {
    CreateUnitOwnerDialog,
    TableLoading
  },
  data () {
    const { areaPerPerson, unit } = tw
    return {
      ErrorMsg: {
        CANT_NOT_BE_EMPTY: '坪數不可為空',
        CANT_NOT_LESS_THEN_ZERO: '坪數不可小於0',
        CANT_NOT_BE_ZERO: '坪數不可為0'
      },
      Tooltips: {
        ALREADY_REGISTERED: '已報到戶別資料無法修改，請先取消報到再進行異動。',
        ALREADY_UNREGISTERED: '已簽退戶別資料無法修改，請先取消簽退再進行異動。'
      },
      listData: [],
      deleteList: [],
      tableKey: 0,
      loading: false,
      areaPerPerson,
      unit
    }
  },
  mounted () {
    this.getListData()
    this.$nextTick(() => {
      this.rowMove()
    })
  },
  methods: {
    // 取得列表資料
    getListData () {
      this.loading = true
      apiUnitOwnerAssembly.GetUnitOwnerList(
        {
          AssemblyId: this.$route.params.id || this.$route.query.id
        }
      ).then(res => {
        res.data.map(item => { item.mode = 'NotChanged' })
        res.data.map(item => { item.unitOwnerId = item.id })
        this.listData = res.data
        this.loading = false
      }).catch((err) => {
        console.log('錯誤訊息：', err.response)
      })
    },
    // 拖曳事件
    rowMove () {
      const tbody = document.querySelector('.editRegisterListTable .el-table__body-wrapper tbody')
      const _this = this
      Sortable.create(tbody, {
        handle: '.rowClass',
        disabled: false,
        animation: 150,
        ghostClass: 'rowMove',
        onEnd (e) {
          _this.$nextTick(() => {
            _this.listData.splice(e.newIndex, 0, _this.listData.splice(e.oldIndex, 1)[0])
          })
        }
      })
    },
    delRow (index) {
      console.log(index)
      const row = this.listData[index]
      row.mode = 'Delete'
      row.index = index
      this.deleteList.push(row)
      this.tableKey++
    },
    editRow (index) {
      console.log(index)
      if (this.listData[index].mode !== 'Add') { this.listData[index].mode = 'Edit' }
    },
    createRow (val) {
      this.listData.push({
        tabletId: val.TabletId,
        tabletName: val.TabletNote,
        unitOwnerName: '',
        tabletArea: 0,
        mode: 'Add'
      })
    },
    deleteCreatingUnitOwner (index) {
      this.listData.splice(index, 1)
    },
    // 已刪除的戶別未儲存時被新增
    deletedToCreate (index) {
      console.log(index)
      this.listData[index].mode = 'NotChanged'
      this.tableKey++
    },
    syncCheckRule () {
      // 是否有錯誤訊息
      let errormsg = ''
      this.listData.forEach(item => {
        // eslint-disable-next-line eqeqeq
        if (item.tabletArea == '') errormsg = this.ErrorMsg.CANT_NOT_BE_EMPTY
        // eslint-disable-next-line eqeqeq
        else if (item.tabletArea == 0) errormsg = this.ErrorMsg.CANT_NOT_BE_ZERO
        else if (item.tabletArea < 0) errormsg = this.ErrorMsg.CANT_NOT_LESS_THEN_ZERO
      })
      return errormsg
    },
    save () {
      return apiUnitOwnerAssembly.UnitOwner.ModifyUnitOwners(
        {
          assemblyId: this.$route.query.id,
          modifyUnitOwnerDtos: this.listData
        }
      )
    },
    // table - header 樣式
    headerCellStyle ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 4) { return 'redStar' }
    },
    // table - row 樣式
    rowCellStyle ({ row, rowIndex }) {
      // eslint-disable-next-line eqeqeq
      if (row.mode == 'Delete') { return 'rowDelete rowClass' } else { return 'rowClass' }
    }
  }
}
</script>
<style lang="sass" scoped>
#EditRegisterList_main
  ::v-deep .el-table
    +basicTable
    .el-table__header
      th
        background-color: $bgDark3
        &.redStar
          +redStar()
          &::before
            left: 0
            top: 12px
    .el-table__body
      .el-form-item
        margin-bottom: 0
      .rowClass
        cursor: move
      .rowDelete
        background-color: $bgDark1
        opacity: 0.5
    .el-input
      text-align: left
      .el-input__inner
        text-align: left
      input::-webkit-outer-spin-button,input::-webkit-inner-spin-button
        -webkit-appearance: none
        margin: 0
      &.borderRed
        .el-input__inner
          border: $dangerColorHover 1px solid
    .errorTxt
      span
        color: $dangerColor
        font-size: 12px
    .rowMove
      background-color: $mainColor
    .delRowButton
      width: 62px
  .addButton
    padding: 12px
    background-color: $bgDark3

</style>
